import { isTypeWysiwygSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulTableOfContentsSetting from './ContentfulTableOfContentsSetting';
import BackToTopCta from './util/BackToTopCta';
import MarkdownText from './util/MarkdownText';

const ContentfulWysiwygSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeWysiwygSection(entry)) {
    return null;
  }

  return (
    <div className='bg-white sm:max-w-[600px] sm:mx-auto my-6 sm:my-12 text-left'>
      {entry.fields?.header?.length && (
        <h2 className='text-2xl sm:text-4xl leading-7 text-gray-500 sm:leading-10 my-3 sm:my-6 font-semibold font-header'>
          {entry.fields.header}
        </h2>
      )}
      {/* TODO: This is actually Markdown */}
      <MarkdownText text={entry.fields.content ?? ''} />
      <BackToTopCta enabled={entry.fields.backToTopCta} />
      <ContentfulTableOfContentsSetting entry={entry.fields.tocSetting} />
    </div>
  );
};

export default ContentfulWysiwygSection;
